<div class="col" [ngClass]="hintBubbleContainerClass">
    <div class="col hint-text-container hint-bubble" [ngClass]="arrowClass">
        <div *ngIf="hintHeader" [ngClass]="hintHeaderClass">{{hintHeader}}</div>
        <div class="hint-text" [ngClass]="hintTextClass">{{hintText}}</div>
        <ng-content></ng-content>
    </div>
</div>